import { DatePickerComponent } from './DatePicker';
import { Monthday } from './MonthDay';
import { WateringComponent } from './Watering';
import { TextAreaComponent } from './TextArea';
import { RelationSelectComponent } from './RelationSelect';

export type WidgetProps<T> = {
	value: T;
	uiSchema?: any;
	onChange: (value: T) => void;
};

const WIDGETS: {
	[key: string]: (props: WidgetProps<any>) => JSX.Element;
} = {
	monthday: Monthday,
	date: DatePickerComponent,
	watering: WateringComponent,
	textarea: TextAreaComponent,
	select: RelationSelectComponent,
};

type findWidgetProps = ((props: WidgetProps<any>) => JSX.Element) | null;

export const findWidget = (widget: string): findWidgetProps => {
	// Check if the widget is registered
	if (typeof widget === 'string' && widget in WIDGETS) {
		// Convert widget to keyof typeof WIDGETS
		const widgetKey = widget as keyof typeof WIDGETS;
		return WIDGETS[widgetKey];
	}
	return null;
};
